import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-mb-case-detail-skeleton',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="space-y-8 loading-container">
      <!-- Title skeleton -->
      <div class="h-8 skeleton-loading w-3/4 skeleton-item"></div>

      <!-- Case type and severity skeleton -->
      <div class="flex flex-row gap-8 items-center pb-4">
        <div class="flex gap-2 items-center">
          <div class="h-5 skeleton-loading w-20 skeleton-item"></div>
          <div class="h-8 skeleton-loading w-24 skeleton-item"></div>
        </div>
        <div class="flex gap-2 items-center">
          <div class="h-5 skeleton-loading w-16 skeleton-item"></div>
          <div class="h-6 skeleton-loading w-20 skeleton-item"></div>
        </div>
      </div>

      <!-- Description skeleton -->
      <div class="space-y-2">
        <div class="h-4 skeleton-loading w-full skeleton-item"></div>
        <div class="h-4 skeleton-loading w-3/4 skeleton-item"></div>
        <div class="h-4 skeleton-loading w-1/2 skeleton-item"></div>
      </div>

      <!-- Supporting attachments skeleton -->
      <div class="space-y-4">
        <div class="h-5 skeleton-loading w-52 skeleton-item"></div>
        <div class="flex flex-row gap-6 mb-4 flex-wrap">
          <div class="w-40 h-10 skeleton-loading rounded-sm skeleton-item"></div>
        </div>
      </div>

      <!-- Details sections skeleton -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 justify-between mt-4">
        @for (section of [1, 2, 3, 4]; track section) {
          <div class="flex flex-col gap-1 w-2/3 md:mt-0 mt-4">
            <div class="h-5 skeleton-loading w-24 mb-4 skeleton-item"></div>
            @for (item of [1, 2, 3, 4]; track item) {
              <div class="flex justify-between w-full mb-4 gap-2">
                <div class="h-4 skeleton-loading w-16 skeleton-item"></div>
                <div class="h-4 skeleton-loading w-24 skeleton-item"></div>
              </div>
            }
          </div>
        }
      </div>
  </div>
  `,
  styleUrl:'../mb-casetimeline-skeleton/mb-case-time-line-skeleton.component.css'
})
export class MbCaseDetailSkeletonComponent {
}
